<template>
  <div class="message-center-container">
    <div class="message-header">
      <i class="el-icon-message-solid"></i>
      <span>我的消息</span>
    </div>
    <div v-if="messages && messages.length" class="message-list">
      <div
        class="message-card"
        v-for="msg in messages"
        :key="msg.id"
        @click="showDetail(msg)"
      >
        <div class="message-card-header">
          <i class="el-icon-bell message-card-icon"></i>
          <div class="message-title">{{ msg.title }}</div>
          <div class="message-date">{{ msg.date }}</div>
        </div>
        <div class="message-content">{{ msg.content }}</div>
      </div>
    </div>
    <div v-else class="message-empty">
      <img
        src="https://img.icons8.com/ios/452/nothing-found.png"
        alt="暂无消息"
        class="message-empty-img"
      />
      <div class="message-empty-title">暂无消息</div>
      <div class="message-empty-desc">你还没有收到任何消息通知</div>
      <div class="message-empty-actions">
        <router-link :to="{ name: 'indexPage' }">
          <el-button type="primary">去首页看看</el-button>
        </router-link>
        <router-link :to="{ name: 'Mycollection' }">
          <el-button>我的收藏</el-button>
        </router-link>
      </div>
    </div>
    <el-dialog
      title="消息详情"
      :visible.sync="dialogVisible"
      width="480px"
      :show-close="true"
      class="message-dialog"
    >
      <div class="message-dialog-content">
        <div class="message-dialog-title">{{ currentMsg.title }}</div>
        <div class="message-dialog-date">{{ currentMsg.date }}</div>
        <div class="message-dialog-body">
          {{ currentMsg.content }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      currentMsg: {},
      messages: []
    };
  },
  methods: {
    showDetail(msg) {
      this.currentMsg = msg;
      this.dialogVisible = true;
    },
    closei() {
      this.dialogVisible = false;
    },
    handleClose(done) {
      console.log(done);
    }
  }
};
</script>
<style scoped>
.message-center-container {
  max-width: 540px;
  margin: 48px auto 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 36px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.message-header {
  display: flex;
  align-items: center;
  font-size: 26px;
  font-weight: 800;
  color: #f1787f;
  margin-bottom: 36px;
  gap: 12px;
  letter-spacing: 2px;
  text-shadow: 0 2px 8px rgba(241, 120, 127, 0.08);
}
.message-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.message-card {
  background: #fafbfc;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 18px 22px 14px 22px;
  cursor: pointer;
  transition: box-shadow 0.2s, background 0.2s;
  border: 1px solid #f3f3f3;
  position: relative;
}
.message-card:hover {
  background: #fff6f7;
  box-shadow: 0 4px 16px rgba(241, 120, 127, 0.1);
  border-color: #f1787f33;
}
.message-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 10px;
}
.message-card-icon {
  color: #f1787f;
  font-size: 22px;
}
.message-title {
  font-size: 17px;
  font-weight: 700;
  color: #222;
  flex: 1;
}
.message-date {
  color: #aaa;
  font-size: 13px;
  min-width: 90px;
  text-align: right;
}
.message-content {
  color: #444;
  font-size: 15px;
  line-height: 1.7;
  padding-left: 32px;
}
.message-card:not(:last-child)::after {
  content: "";
  display: block;
  height: 1px;
  background: #f3f3f3;
  margin: 16px -22px 0 -22px;
}
.message-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  width: 100%;
  background: #f8f8fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 32px 0;
}
.message-empty-img {
  width: 150px;
  margin-bottom: 18px;
  opacity: 0.85;
}
.message-empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
}
.message-empty-desc {
  color: #888;
  font-size: 15px;
  margin-bottom: 18px;
}
.message-empty-actions {
  display: flex;
  gap: 16px;
}
.message-dialog .el-dialog__header {
  padding: 18px 24px 0 24px;
  font-size: 18px;
  color: #f1787f;
  font-weight: 700;
  border-bottom: 1px solid #f3f3f3;
}
.message-dialog-content {
  padding: 24px 24px 12px 24px;
}
.message-dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
}
.message-dialog-date {
  color: #888;
  font-size: 14px;
  margin-bottom: 12px;
}
.message-dialog-body {
  color: #444;
  font-size: 15px;
  line-height: 1.7;
}
@media (max-width: 600px) {
  .message-center-container {
    padding: 12px 2vw 12px 2vw;
    max-width: 98vw;
  }
  .message-empty-img {
    width: 100px;
  }
  .message-card {
    padding: 12px 8px 10px 8px;
  }
}
</style>
<style>
.mess_details .el-dialog {
  min-height: 400px;
}
.mess_details .el-dialog__header {
  padding: 0 0 0 20px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #3e3e3f;
  border-bottom: 1px solid #ddd;
}
.mess_details .el-dialog__title {
  font-size: 16px;
  color: #3e3e3f;
}
.mess_details .el-dialog__body {
  padding: 0;
}
</style>
